import React from 'react';
import { Textarea } from '@leagueplatform/genesis-commons';
import { ControlledFormField } from '@leagueplatform/web-common';
import { useIntl } from '@leagueplatform/locales';

export interface TextAreaInputProps {
  name: string;
  id: string;
  labelText?: string;
  required?: boolean;
  placeholder?: string;
  maxLength?: number;
  regex?: string;
  defaultValue?: string;
}

export const TextAreaInput = ({
  name,
  id,
  placeholder,
  labelText,
  required,
  maxLength,
  regex,
  defaultValue,
}: TextAreaInputProps) => {
  const { formatMessage } = useIntl();
  const inputRules = {
    ...(required && {
      required: {
        value: true,
        message: formatMessage({ id: 'THIS_FIELD_IS_REQUIRED' }),
      },
    }),
    ...(maxLength && {
      maxLength: {
        value: maxLength,
        message: `You are over the maximum character limit (${maxLength})`,
      },
    }),
    ...(regex && {
      pattern: {
        value: new RegExp(regex),
        message: 'Please enter a valid format',
      },
    }),
  };

  return (
    <ControlledFormField
      id={id}
      name={name}
      inputOptions={{
        ...inputRules,
        value: defaultValue,
      }}
      label={labelText}
    >
      {/* TODO: PCHAT-3007 use textarea from genesis-core */}
      <Textarea
        id={id}
        name={name}
        placeholder={placeholder}
        aria-required={required}
      />
    </ControlledFormField>
  );
};
